import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { useBillingSync } from '@/hooks/billing/use-billing-sync.hook'
import { useDeferredBillingTracking } from '@/hooks/billing/use-deferred-billing-tracking.hook'

import { LoadingScreen } from './loading-screen.atom'

export const BillingGuard = (): ReactNode => {
  const { isLoading, error } = useBillingSync()
  useDeferredBillingTracking()

  if (isLoading) {
    return <LoadingScreen />
  }

  void error

  return <Outlet />
}
